<div class="ai-chat-button" 
  (click)="toggleChat()"
  oneTooltipPosition="bottom"
  [oneTooltipSkipUnderline]="true"
  [oneTooltip]="'ai_chat.button_tooltip' | transloco">
  <one-icon name="sparkles-sharp"></one-icon>
</div>
